window.BasicInfoForm = function (scope, hUser) {
    var self = this;
    var formName = "basic-info-form";
    var _protected = BaseForm.call(self, formName, scope);
    
    self.data = {
        phone: hUser.data.user.phone
    };
    
    self.save = function() {
        var defer = $q.defer();

        var data = {phone: window.intlTelInputUtils.formatNumber(self.data.phone, undefined, window.intlTelInputUtils.numberFormat.E164)};

        SettingsAPI
            .savePersonalInformation(data)
            .then(function (res) {
                hUser.data.user.phone = self.data.phone;
                defer.resolve();
            },
        function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };
    
    self.load = function () {
        
    };
};
